import React from 'react';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { Available } from './styled';

export const ModalAvailable: React.FC = () => {
  const history = useHistory();

  const totalConsume = useSelector(state => state.package.dataConsume.totalAds);
  const isLoading = useSelector(state => state.package.isFetchingConsume);

  const handleClickButton = (e) => {
    e.preventDefault();
    history.push('/mi-cuenta/listado-paquetes');
  };

  return (
    <Available href="#" onClick={e => handleClickButton(e)}>
      {
        isLoading ? 'cargando...' : `Avisos Disponibles: ${totalConsume}`
      }
    </Available>
  );
};